<template>
  <div id="app">
    <nav v-if="authStore.isAuthenticated" class="navbar">
      <div class="nav-left">
        <router-link to="/" class="nav-brand">🏭 App Manager</router-link>
        <router-link to="/" class="nav-link">Dashboard</router-link>
      </div>
      <div class="nav-right">
        <div class="user-info">
          <img
            v-if="authStore.userPhoto"
            :src="authStore.userPhoto"
            :alt="authStore.userName"
            class="avatar"
          />
          <span class="user-name">{{ authStore.userName }}</span>
        </div>
        <button @click="handleLogout" class="btn btn-secondary btn-sm">
          Déconnexion
        </button>
      </div>
    </nav>

    <main>
      <router-view />
    </main>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = useRouter()
const authStore = useAuthStore()

async function handleLogout() {
  await authStore.logout()
  router.push('/login')
}
</script>

<style scoped>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.5rem;
  background: var(--color-bg-card);
  border-bottom: 1px solid var(--color-border);
}

.nav-left {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.nav-brand {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--color-text);
}

.nav-link {
  color: var(--color-text-muted);
  font-size: 0.875rem;
}

.nav-link:hover,
.nav-link.router-link-active {
  color: var(--color-text);
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.user-name {
  font-size: 0.875rem;
  color: var(--color-text-muted);
}

.btn-sm {
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
}

main {
  flex: 1;
}

@media (max-width: 768px) {
  .navbar {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }

  .user-name {
    display: none;
  }
}
</style>
